import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

export const getActivityReports = async () => {
    try {
        const response = await axios.get(`${baseUrl}/ActivityReport/GetActivityReports`);
        return response.data;
    } catch (error) {
        console.error('Error fetching activity reports:', error);
        throw error;
    }
};
